module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av228-f2f87ac66c536b0f1610303f027e22b2.jpg";